module.exports = __webpack_public_path__ + "assets/images/arrow-right.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/arrow-right.png
// module id = 1483
// module chunks = 1